export default class MultipleIndex extends ApplicationController {

  expandUser (e) {
    const cards = document.querySelectorAll(".multiple-user-card")
    cards.forEach(element => {
      element.classList.toggle("h-150")
    })
  }
}
